import React from "react";

const FeatureList = ({ feature }) => {
  return (
    <div className="feature">
      <div className="feature-icon">
        <i className={feature.icon}></i>
      </div>
      <div className="content">
        <h4 className="title">{feature.title}</h4>
        <p className="desc">{feature.description}</p>
      </div>
    </div>
  );
};

export default FeatureList;
